(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('DataManagerIndexCtrl', DataManagerIndexController);

  DataManagerIndexController.$inject = [
    '$rootScope',
    'LoadingService'
  ];

  function DataManagerIndexController($rootScope, LoadingService) {
    LoadingService.showLoading();
    $rootScope.initialize
      .then(LoadingService.hideLoading)
      .catch($rootScope.errorRootInitialize);
  }
}());
